import React from 'react'
import SharedNotesModal from './SharedNotesModal'

const ModalPodNotes = ({closeModal, podInfo}) => {
    const podName = podInfo?.description ?? podInfo?.name ?? '';

    return (
        <SharedNotesModal
            closeModal={closeModal}
            entityInfo={podInfo}
            title={`${podName}: Pod Notes`}
            fetchPath='/machine_notes/machine/'
            createPath='/machine_notes/'
            createEntityKey='machine'
        />
    )
}

export default ModalPodNotes